(function () {
    var searchHistory = {
        init: function () {
            searchHistory.controls();
        },
        controls: function () {
            var $body = $('body');
            $body.on('click', '.search-history__clearlink a', function () {
                $.ajax({
                    url: '/action/ajaxClearSearchHistory',
                    success: function (data) {
                        $('.search-history').html(
                            "<p class='empty-search-history'> You do not have search history</p>"
                        );
                    },
                });
            });
        },
    };
    UX.searchHistory = searchHistory;
    if ($('.search-history').length) {
        UX.searchHistory.init();
    }
})();
